// initial state
const state = {
  searchAdminButton: null,

  checkingCart: null,

  navHeight: 0,

  routeTransition: null,

  // In-app route that led into the current studio run. Item-to-item replaces
  // preserve it so a direct/external visitor never acquires an unsafe back.
  studioBackRoute: null,
}

// mutations
const mutations = {
  setSearchAdminButton (state, data) {
    state.searchAdminButton = data
  },

  setCheckingCart (state, data) {
    state.checkingCart = data
  },

  setNavHeight(state, data) {
    state.navHeight = data
  },

  setRouteTransition(state, scope = null) {
    state.routeTransition = scope || null
  },

  setStudioBackRoute(state, route = null) {
    state.studioBackRoute = route
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
